// extracted by mini-css-extract-plugin
module.exports = {"sticky-footer":"StickyFooter_sticky-footer__2Tm-G","spinner":"StickyFooter_spinner__27zA5"};